import { Button, Grid } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useAppContext } from "AppContext";
import GKClientDataGrid from "components/GKClientDataGrid";
import { useState } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "utils/axiosInstance";
import AddIdenifier from "./AddIdentifierModal";

const PricesPage = () => {
  const { id } = useParams();
  const [identifierRowData, setIdentifierRowData] = useState({});
  const [isOpenIdentifier, setIsOpenIdentifier] = useState(undefined);

  const {
    state: { currentUser },
  } = useAppContext();

  const isDisabled = currentUser?.phone === "9911223344";

  const {
    data: priceData,
    isFetching: priceFetching,
    refetch,
  } = useQuery({
    queryKey: ["ADMIN_INSTRUMENT_META"],
    queryFn: async () => axiosInstance.get(`/admin-instrument-meta/${id}/`),
  });

  const priceColumns = [
    {
      headerName: "Code Type",
      field: "codeType",
      flex: 1,
      disableColumnMenu: true,
      minWidth: 150,
    },
    {
      headerName: "Code",
      field: "code",
      flex: 1,
      disableColumnMenu: true,
      minWidth: 150,
    },
    {
      headerName: "Status",
      field: "status",
      flex: 1,
      disableColumnMenu: true,
      minWidth: 150,
    },
  ];
  return (
    <Grid container>
      <Grid item xs={12}>
        <GKClientDataGrid
          loading={priceFetching}
          columns={priceColumns}
          headerComponent={
            <Button
              sx={{
                fontSize: "0.7rem",
                fontFamily: '"Arial", sans-serif',
                textTransform: "none",
              }}
              onClick={() => {
                setIdentifierRowData({});
                setIsOpenIdentifier(!isOpenIdentifier);
              }}
              variant="contained"
              disabled={isDisabled}
            >
              Add identifiers
            </Button>
          }
          rows={
            priceData?.data?.data?.map((data, index) => {
              return {
                ...data,
                id: index,
              };
            }) || []
          }
          onRowClick={(row) => {
            setIdentifierRowData(row.row);
            setIsOpenIdentifier(true);
          }}
        />
      </Grid>
      {isOpenIdentifier && (
        <AddIdenifier
          isModalOpen={isOpenIdentifier}
          setIsModalOpen={setIsOpenIdentifier}
          refetch={refetch}
          identifierRowData={identifierRowData}
        />
      )}
    </Grid>
  );
};

export default PricesPage;
